const styles = {
  giftCardListContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    gap: '1.5rem 2%',
  },
  // backgroundColor/color are intentionally omitted here — they're theme-token
  // dependent (see GMGiftDetailView.tsx, which merges in token.colorTextBase/
  // colorBgContainer at render time) since a plain style object like this one
  // can't call theme.useToken() itself.
  textWithColor: {
    textAlign: 'center',
    padding: '0px',
    width: '100%',
    marginTop: '10px',
    borderRadius: '8px',
  },
  pricing_table: {
    display: 'inline-table',
    marginTop: '15px',
    fontWeight: 'bold',
    border: '2px solid',
    borderRadius: '10px',
    width: '100%',
  },
  pricing_table_col: {
    display: 'table-cell',
    padding: '10px 20px',
    cursor: 'pointer',
    borderRadius: '8px',
  },
};

export default styles;
